<template>
  <div class="StepProgressBar">
    <div class="StepProgressBar-header">
      <Transition name="fade-slide-text" mode="out-in">
        <p :key="currentStepLabel" class="StepProgressBar-headerText">
          {{ currentStepLabel }}
        </p>
      </Transition>
    </div>

    <ProgressBar
      class="StepProgressBar-progress"
      :progress="currentStepProgress"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ProgressBar from '../ProgressBar/ProgressBar.vue';
import type { StepProgressBarProps } from './StepProgressBar.model';

const props = defineProps<StepProgressBarProps>();

const currentStepData = computed(() => {
  const stepIndex = Math.max(0, Math.min(props.step - 1, props.steps.length - 1));
  return props.steps[stepIndex] || { label: '', percentage: 0 };
});

const currentStepLabel = computed(() => currentStepData.value.label);
const currentStepProgress = computed(() => currentStepData.value.percentage);
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/layout';
@use '@cvo/ui/styles/utils/text';
@use '@cvo/ui/styles/utils/responsive';

@layer cvo-ui {
  .StepProgressBar {
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-10;
    text-align: center;
    overflow: hidden;
    align-items: center;

    &-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: end;

      color: vars.$molecules-loader-text-color;
      @include text.heading-responsive('h6', 'h4');
    }
  }
}
</style>